import { animate, animation, style } from '@angular/animations';
/** Animation for components entering/leaving offscreen */
export default animation([
    style({ transform: 'translateX({{ from }}' }),
    animate('250ms ease-in-out', style({ transform: 'translateX({{ to }})' }))
]);
